import React from 'react';

const ChangePassword = () => {
  return (
    <div className="p-8">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-white mb-4">Change Password</h1>
        <p className="text-gray-400">
          Click on "Change Password" in the sidebar to open the password change modal.
        </p>
      </div>
    </div>
  );
};

export default ChangePassword;


